import { createFileRoute } from '@tanstack/react-router';
import { ManageSuppliersPage } from '@/pages/member-portal/suppliers/ManageSuppliersPage';

function MemberPortalManageSuppliersRoute() {
	return <ManageSuppliersPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/suppliers')({
	component: MemberPortalManageSuppliersRoute,
});
